import api from './api';

// Authentication API functions
export const authApi = {
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    try {
      await api.put('/api/auth/changePassword', {
        current_password: currentPassword,
        new_password: newPassword
      });
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  }
};

